import MOCKED_ORGANISATIONS from "./organisations/organisations";

export const MOCKED_ORGANISATIONS_STATE = {
  organisations: MOCKED_ORGANISATIONS
};
